"use client";

import * as React from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "../lib/utils";

export function DateRangePicker({ date, className }) {
  
  // Determine the currently selected year
  // Defaults to current year if no date provided, but App.js passes the previous year
  const currentYear = new Date().getFullYear();
  const selectedYear = new Date().getFullYear() - 1;

  return (
    <div className={cn("grid gap-2", className)}>
      {/* Replaced Popover/Button with a static div */}
      <div
        className={cn(
          "w-[180px] flex items-center justify-start text-left font-normal border border-slate-200 bg-white h-10 px-4 py-2 rounded-md cursor-default",
          !date && "text-muted-foreground"
        )}
      >
        <CalendarIcon className="mr-2 h-4 w-4 opacity-50" />
        <span className="text-slate-600">
          <span className="font-bold text-[var(--accent-primary)] tracking-tight">Tax Year: {selectedYear}</span>
        </span>
      </div>
    </div>
  );
}